import { Button, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';

interface Properties {
  isOpen: boolean;
  onClose: () => void;
  itemName: string;
  onDelete: () => void;
}

const DeleteModal = ({ isOpen, onClose, itemName, onDelete }: Properties) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered blockScrollOnMount={false}>
      <ModalOverlay />
      <ModalContent width='411px' maxWidth='90vw' borderRadius='14px' p='18px'>
        <ModalBody p={0}>
          <Flex direction='column' align='center' gap='21px'>
            <Text
              textAlign='center'
              fontFamily='Comfortaa'
              fontWeight='bold'
              fontSize='18px'
              color='#121826'
            >
              Delete {itemName}
            </Text>
            <Text
              textAlign='center'
              fontFamily='Roboto Regular'
              fontSize='13px'
              lineHeight='16px'
              color='#708090'
            >
              This action will permanently remove {itemName}. You won&apos;t be able to recover it.
            </Text>
            <Flex gap='18px' width='100%'>
              <Button
                flex={1}
                bg='white'
                border='1px solid #D9D9D9'
                borderRadius='11px'
                fontFamily='Roboto Regular'
                fontWeight='500'
                fontSize='13px'
                color='#121826'
                p='14px'
                height='auto'
                transition='transform 0.1s ease, background 0.15s ease'
                _hover={{ bg: 'gray.50' }}
                _active={{ transform: 'scale(0.97)' }}
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                flex={1}
                bg='#FE552F'
                borderRadius='11px'
                fontFamily='Roboto Bold'
                fontWeight='700'
                fontSize='13px'
                color='white'
                p='14px'
                height='auto'
                transition='transform 0.1s ease, background 0.15s ease'
                _hover={{ bg: '#E54B29' }}
                _active={{ transform: 'scale(0.97)' }}
                onClick={onDelete}
              >
                Yes, Delete
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DeleteModal;
